import { tableCellClasses } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import {
  theme as designTokenTheme,
  type PantryPalette,
  type PantryPaletteOptions,
} from '@side/pantry';

declare module '@mui/material/styles' {
  // NOTE: Palette must be an interface to correctly override Mui's types
  interface Palette extends PantryPalette {
    docInput: {
      background: string;
      blue: string;
      black: string;
      gray: string;
    };
    docTagging: {
      buyer1: string;
      buyer2: string;
      buyer3: string;
      buyer4: string;
      seller1: string;
      seller2: string;
      seller3: string;
      seller4: string;
      agent1: string;
      agent2: string;
      agent3: string;
      agent4: string;
      agent5: string;
      agent6: string;
      agent7: string;
      supervisingBroker1: string;
      other1: string;
      other2: string;
    };
  }

  interface PaletteOptions extends PantryPaletteOptions {
    docInput: {
      background: string;
      blue: string;
      black: string;
      gray: string;
    };
    docTagging: {
      buyer1: string;
      buyer2: string;
      buyer3: string;
      buyer4: string;
      seller1: string;
      seller2: string;
      seller3: string;
      seller4: string;
      agent1: string;
      agent2: string;
      agent3: string;
      agent4: string;
      agent5: string;
      agent6: string;
      agent7: string;
      supervisingBroker1: string;
      other1: string;
      other2: string;
    };
  }
  interface TypographyVariants {
    defaultDocViewerFontSize: string;
    defaultDocViewerTextAlign: string;
  }
  interface TypographyVariantsOptions {
    defaultDocViewerFontSize: string;
    defaultDocViewerTextAlign: string;
  }
}

export const theme = createTheme({
  ...designTokenTheme,
  components: {
    ...designTokenTheme.components,
    MuiTableCell: {
      styleOverrides: {
        root: ({ theme: t }) => ({
          borderBottom: 'none',
          borderTop: `1px solid ${t.palette.grey[400]}`,
          paddingLeft: t.spacing(2),
          paddingTop: t.spacing(1),
          paddingBottom: t.spacing(1),
          '&:first-of-type': {
            paddingLeft: t.spacing(3),
          },
          '&:last-of-type': {
            paddingRight: t.spacing(2),
          },
          ...t.typography.body2,
          [`&.${tableCellClasses.head}`]: {
            ...t.typography.subtitle2,
            height: '38px',
            borderColor: t.palette.other.outlineBorder,
          },
        }),
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: ({ theme: t }) => ({
          backgroundColor: t.palette.background.default,
        }),
      },
    },
  },
  palette: {
    ...designTokenTheme.palette,
    docInput: {
      background: '#FFEE7E',
      blue: '#1717cf',
      black: designTokenTheme.palette.common.black,
      gray: '#383838',
    },
    docTagging: {
      buyer1: '#D724D4',
      buyer2: '#F35E93',
      buyer3: '#883086',
      buyer4: '#C3001A',
      seller1: '#EED924',
      seller2: '#3EC300',
      seller3: '#A4D547',
      seller4: '#2f760c',
      agent1: '#1890D4',
      agent2: '#93D8FF',
      agent3: '#36D4CF',
      agent4: '#A1A3F7',
      agent5: '#00BFFF',
      agent6: '#006EFF',
      agent7: '#5558E0',
      supervisingBroker1: '#E8AB74',
      other1: '#B8720A',
      other2: '#E0A830',
    },
  },
  typography: {
    ...designTokenTheme.typography,
    defaultDocViewerFontSize: designTokenTheme.typography.pxToRem(15.36),
    defaultDocViewerTextAlign: 'left',
  },
});
